<div mat-dialog-content class="custom-dialog">
     <p class="main-box-title-12">Your project has been successfully created. Autosave is now enabled.</p>
</div>
